export const useFileFormMixin = controller => {
  Object.assign(controller, {
    setFileFieldFiles(event) {
      const { dataTransfer, formID } = event.detail
      if (formID === this.uploadID) {
        this.fileFieldTarget.files = dataTransfer.files
        this.dataTransfer = dataTransfer
        this.filename = dataTransfer.files[0].name
      }
    }
  })
  Object.defineProperty(controller, "uploadID", {
    get: function() {
      return this.data.get("upload-id")
    },
    set: function(val) {
      this.data.set("upload-id", val)
    }
  })
  Object.defineProperty(controller, "file", {
    get: function() { return this.dataTransfer ? this.dataTransfer.files[0] : null }
  })
}



// WEBPACK FOOTER //
// ./app/javascript/shared/assetHelpers.js